module.exports = __webpack_public_path__ + "static/The_three_of_us_in_Hawaii-05e1b8065fa3f214e34965c7286485b8.jpg";